import { useState } from "react";
import { useLanguageContext } from "../../context/LanguageContext";

export default function DragAndDropFile({ xfile, xsetFile }) {
  const [isDragging, setIsDragging] = useState(false);

  const { t } = useLanguageContext();

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const file = e.dataTransfer.files?.[0];
    if (file) xsetFile(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragEnter = () => setIsDragging(true);
  const handleDragLeave = () => setIsDragging(false);

  return (
    <div className="flex flex-col items-center justify-center w-80 gap-2">
      <label
        htmlFor="dropzone-file"
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        className={`flex flex-col items-center justify-center w-full h-40 rounded-lg border border-dashed cursor-pointer transition
          ${isDragging ? "bg-gray-800 border-gray-400" : "bg-neutral-secondary-medium border-gray-600 hover:bg-gray-800"}`}
      >
        <div className="flex flex-col items-center justify-center text-body pt-5 pb-6">
          <svg className="w-8 h-8 mb-4" aria-hidden="true" fill="none" viewBox="0 0 24 24">
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 17h3a3 3 0 0 0 0-6h-.025a5.56 5.56 0 0 0 .025-.5A5.5 5.5 0 0 0 7.207 9.021C7.137 9.017 7.071 9 7 9a4 4 0 1 0 0 8h2.167M12 19v-9m0 0-2 2m2-2 2 2"
            />
          </svg>

          <p className="mb-2 text-sm">{t("component", "dragAndDropImage", "click")}</p>
          <p className="text-xs">SVG, PNG, JPG or GIF</p>
        </div>

        <input id="dropzone-file" type="file" className="hidden" onChange={(e) => xsetFile(e.target.files?.[0] || null)} />
      </label>

      {xfile && (
        <p className="text-sm text-gray-300 truncate max-w-full">
          Selected file: <span className="font-medium">{xfile.name}</span>
        </p>
      )}
    </div>
  );
}
